var render = function render(){var _vm=this,_c=_vm._self._c;return _c('html-sheet',{ref:"sheet",attrs:{"title":_vm.$t('tripDetails.outsideSponsoredArea.helpSheetTitle'),"content":_vm.$t('tripDetails.outsideSponsoredArea.helpSheetBody')}})
}
var staticRenderFns = []

export { render, staticRenderFns }